import { FieldHeaders, TableFields } from '../../components/table/fieldsConfigTypes';
import { Log } from './logsContext';

export const logTableFields: TableFields<Log> = [
  'timestamp',
  'device_label',
  'log',
  'type',
  'device_owner',
  'received',
];

export const logFieldHeaders: FieldHeaders = {
  serial_number: 'Serial Number',
  device_owner: 'Owner',
  device_label: 'Label',
  log: 'Log Message',
  type: 'Type',
  timestamp: 'Timestamp',
  received: 'Received',
};